// 04/09/2020 : Added By Mahmoudi Mohamed Amine
export class Constant {
    /******************** ApiRoot ********************/
    public static ApiRoot               = 'https://aiventu.com:88/AiventuBackEnd';
    // public static ApiRoot               = 'http://5.135.200.254/Aiventu_Back';
    // public static ApiRoot               = 'http://localhost:51918';
    // Prod
    // public static ApiRoot               = 'https://aiventu.com:88/AiventuBackEnd';
  }
